module.exports = __webpack_public_path__ + "static/media/pic10.b502394c.webp";